import {
  updateBid, carryForward, carryForwardReject, uploadImage, getItemValue, getUserInfo, sendMail, checkWonBid
} from '@/apis/message';
import { MESSAGE } from '../mutation-types';

export const state = {
  wonBid: {},
};

export const getters = {
  wonBid: state => state.wonBid
};

export const mutations = {
  [MESSAGE.CHECK_WON_BID](state, data) {
    state.wonBid = data;
  }
};

export const actions = {
  async updateBid(_, payload) {
    const res = await updateBid(payload);

    return res;
  },
  async carryForward(_, payload) {
    const res = await carryForward(payload);

    return res;
  },
  async carryForwardReject(_, payload) {
    const res = await carryForwardReject(payload);

    return res;
  },

  async uploadImage(_, file) {
    const res = await uploadImage(file);

    return res;
  },

  async getItemValue() {
    const res = await getItemValue();
    if (res.error) {
      return false;
    }

    return res;
  },

  async getUserInfo(_, dataUser) {
    const res = await getUserInfo(dataUser);
    if (res.error) {
      return false;
    }

    return res;
  },

  async sendMail(_, payload) {
    const res = await sendMail(payload);
  },

  async checkWonBid(_, payload) {
    const res = await checkWonBid(payload);
    if (res.error) {
      return false;
    }

    return res;
  }
};
